import React from "react";
import { Theme } from "../../theme";

export const PencilIcon = ({ fill, ...props }) => {
    return (
        <svg
            {...props}
            id="Icon-Pen-Edit-Pencil"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="25.002"
            viewBox="0 0 25 25.002"
        >
            <title>Pencil Icon</title>
            <path
                id="Icon-Pen-Edit-Pencil-2"
                data-name="Icon-Pen-Edit-Pencil"
                d="M25,5.893a2.208,2.208,0,0,1-.661,1.6L22.246,9.582,15.413,2.754,17.507.662A2.208,2.208,0,0,1,19.1,0a2,2,0,0,1,1.542.661L24.282,4.3A2.263,2.263,0,0,1,25,5.893m-11.681-1.1L20.2,11.62,9.9,21.917a1.152,1.152,0,0,1-.33.22L1.144,24.945A.5.5,0,0,1,.869,25a.882.882,0,0,1-.606-.275.855.855,0,0,1-.22-.881L2.8,15.419a1.181,1.181,0,0,1,.22-.33ZM6.6,21.31a9.755,9.755,0,0,0-3.085-2.7L2.191,22.8Z"
                transform="translate(0 0)"
                fill={fill ? fill : Theme.colors.blue}
            />
        </svg>
    );
};
